module.exports = {

    props: {
        value: {
            required: false,
            default: null,
        },
        id: {
            type: String,
            required: false,
            default: '',
        },
        name: {
            type: String,
            required: false,
            default: '',
        },
        label: {
            type: String,
            required: false,
            default: '',
        },
        sublabel: {
            type: String,
            required: false,
            default: '',
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        required: {
            type: Boolean,
            required: false,
            default: false,
        },
        maxlength: {
            type: Number,
            required: false,
            default: 255,
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        focus: {
            type: Boolean,
            required: false,
            default: false,
        },
        autocomplete: {
            type: String,
            required: false,
            default: 'off',
        },
        classControl:{
            required: false,
            default: '',
        }
    },

    methods: {
        updateValue(value, eventType = 'input'){
            this.$emit(eventType, value);
        }
    },

    computed: {

        floating() {
            return config.floating;
        },

        getFieldId() {
            return (this.id == '') ? 'app-input-' + this._uid : this.id;
        },

        getLabel(){
            return this.label;
        },

        getPlaceholder(){
            return this.floating ? this.label : this.placeholder;
        },

        formGroup(){
            return this.floating ? 'form-label-group' : 'form-group';
        }
    }
}
